import type { SVGProps } from "react";

/**
 * bytedance
 * @category Social Media & Brands
 */
export default function IconBytedance(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 32 32' fill='none' aria-hidden {...props}>
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='m19.067 22.236-1.775-.464v-8.47l1.9-.481c1.041-.265 1.916-.48 1.958-.472.033 0 .058 2.328.058 5.179v5.18l-.183-.008c-.108 0-.992-.215-1.958-.464M10.792 20.106c0-2.85.025-5.188.066-5.188.034-.008.909.209 1.959.473l1.891.48-.016 4.22-.025 4.217-1.7.44c-.934.239-1.809.463-1.934.488l-.241.058zM23.542 15.872c0-9.406.008-9.912.15-9.87.074.025.816.216 1.641.423.825.216 1.642.422 1.817.463l.308.084-.042 17.841-1.691.431c-.925.24-1.8.455-1.934.49l-.25.057zM4.542 15.905c0-4.873.025-8.86.067-8.86.033 0 .908.216 1.95.474l1.9.48v7.898c0 4.333-.017 7.889-.034 7.889-.025 0-.908.224-1.958.49l-1.925.487z'
        clipRule='evenodd'
      />
    </svg>
  );
}
